import { resourcesLanguageItalian as raguResourcesLanguageItalian } from '@ragu-components/ord-providers';

import { adminResourcesLanguageItalian } from './adminResources';
import { assignedResourcesLanguageItalian } from './assignedResources';
import { calendarsLanguageItalian } from './calendars';
import { rolesLanguageItalian } from './roles';
import { serviceClassesLanguageItalian } from './serviceClasses';
import { servicesResourcesLanguageItalian } from './servicesResources';
import { systemResourcesLanguageItalian } from './systemResources';
import { userResourcesLanguageItalian } from './userResources/userResourcesLanguageItalian';

import type { ResourcesTranlationMessages } from './resourcesTranslationMessages';

export const resourcesLanguageItalian: ResourcesTranlationMessages = {
  resources: {
    ...raguResourcesLanguageItalian,
    ...calendarsLanguageItalian,
    ...adminResourcesLanguageItalian,
    ...userResourcesLanguageItalian,
    ...servicesResourcesLanguageItalian,
    ...serviceClassesLanguageItalian,
    ...assignedResourcesLanguageItalian,
    ...systemResourcesLanguageItalian,
    ...rolesLanguageItalian,
  },
};
